import React from 'react';
import { Mail, Instagram, Heart, Phone, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <Heart className="w-8 h-8 text-red-500 mr-3" />
              <div>
                <h3 className="text-2xl font-bold text-white">VineMatched</h3>
                <p className="text-sm text-gray-400">EMOTIONAL SUPPORT</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              A safe, anonymous space where you can share your struggles, receive emotional support, and connect with caring listeners who understand your journey.
            </p>
            <div className="flex space-x-4">
              <a 
                href="mailto:connect@vinematched.com" 
                className="flex items-center justify-center w-10 h-10 bg-gray-700 hover:bg-gray-600 rounded-full transition-colors"
                aria-label="Email us"
              >
                <Mail className="w-5 h-5" />
              </a>
              <a 
                href="https://instagram.com/vinematched" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 bg-gray-700 hover:bg-gray-600 rounded-full transition-colors"
                aria-label="Follow us on Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/" 
                  className="text-gray-300 hover:text-white transition-colors flex items-center"
                >
                  <Heart className="w-4 h-4 mr-2" />
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/chat/nhm1gYlqiLR3Wfo5rGssZx7dRhI3" 
                  className="text-gray-300 hover:text-white transition-colors flex items-center"
                >
                  <MessageCircle className="w-4 h-4 mr-2" />
                  Start Talking
                </Link>
              </li>
           
            </ul>
          </div>

          {/* Legal & Support */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Legal & Support</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/privacypolicy" 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/termsofservice" 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link 
                  to="/cookiepolicy" 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Cookie Policy
                </Link>
              </li>
             
            </ul>
          </div>
        </div>

        {/* Crisis Resources */}
        <div className="mt-8 p-6 bg-gray-800 rounded-lg border-l-4 border-red-500">
          <h4 className="text-lg font-semibold mb-3 text-red-400 flex items-center">
            <Phone className="w-5 h-5 mr-2" />
            Crisis Resources
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
            <div>
              <p className="font-medium text-white mb-1">US Crisis Hotline</p>
              <p className="text-gray-300">988 (Call or Text)</p>
            </div>
            <div>
              <p className="font-medium text-white mb-1">Crisis Text Line</p>
              <p className="text-gray-300">Text HOME to 741741</p>
            </div>
            <div>
              <p className="font-medium text-white mb-1">Emergency</p>
              <p className="text-gray-300">911 (US) / 999 (UK) / 112 (EU)</p>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p className="text-gray-400 text-sm">
                © 2025 VineMatched. All rights reserved.
              </p>
              <p className="text-gray-500 text-xs mt-1">
                Made with <Heart className="w-3 h-3 inline text-red-500" /> for those who need support
              </p>
            </div>
            <div className="text-sm text-gray-400 max-w-md">
              <p className="text-center md:text-center">
                <span className="text-red-400 font-medium">Important:</span> We provide emotional support, not professional mental health services. If you're in crisis, please contact emergency services or a mental health professional.
              </p>
              
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;